import { Permissions, User, UserRole } from '@/classes/generated-models'
import { PageNames } from '@/classes/types'
import router from '@/router'

export function hasAnyPermissionCheck(user: User, permissions: Permissions[]): boolean {
  return permissions.some((permission: Permissions) => hasPermissionCheck(user, permission))
}

export function hasPermissionCheck(user: User, permission: Permissions): boolean {
  try {
    return !permission || user.permissions!.includes(Permissions.AccessAll) || user.permissions!.includes(permission)
  } catch (e) {
    console.error('HasPermissionCheck', e)
    return false
  }
}

export function goToStartPageAfterLogin(permissions: Permissions[], loggedInUser: User) {
  let nextPageName = PageNames.Dashboard
  if (permissions.includes(Permissions.Impersonate)) nextPageName = PageNames.Impersonate
  else if (permissions.includes(Permissions.UserManagementPageView)) nextPageName = PageNames.UserManagement
  else if (loggedInUser.companies!.length > 1 && !loggedInUser.combineCompanies) nextPageName = PageNames.SetCompany
  router.push({ name: nextPageName })
}

export enum PermissionAction {
  Read,
  Create,
  Change
}

export function hasUserPermission(user: User, userRole: UserRole, action: PermissionAction): boolean {
  const { Change, Create, Read } = PermissionAction
  switch (userRole) {
    case UserRole.Administrator: {
      switch (action) {
        case Read:
          return hasPermissionCheck(user, Permissions.UserAdministratorRead)
        case Create:
          return hasPermissionCheck(user, Permissions.UserAdministratorCreate)
        case Change:
          return hasPermissionCheck(user, Permissions.UserAdministratorChange)
      }
      return false
    }
    case UserRole.Manager: {
      switch (action) {
        case Read:
          return hasPermissionCheck(user, Permissions.UserManagerRead)
        case Create:
          return hasPermissionCheck(user, Permissions.UserManagerCreate)
        case Change:
          return hasPermissionCheck(user, Permissions.UserManagerChange)
      }
      return false
    }
    case UserRole.SuperAdmin: {
      return false
    }
    case UserRole.Support: {
      switch (action) {
        case Read:
          return hasPermissionCheck(user, Permissions.UserSupportRead)
        case Create:
          return hasPermissionCheck(user, Permissions.UserSupportCreate)
        case Change:
          return hasPermissionCheck(user, Permissions.UserSupportChange)
      }
      return false
    }
    case UserRole.User: {
      switch (action) {
        case Read:
          return hasPermissionCheck(user, Permissions.UserRead)
        case Create:
          return hasPermissionCheck(user, Permissions.UserCreate)
        case Change:
          return hasPermissionCheck(user, Permissions.UserChange)
      }
      return false
    }
  }

  return false
}
